import { render, staticRenderFns } from "./mallRegisterBusinessTypeConfigModal.vue?vue&type=template&id=56146eab"
import script from "./mallRegisterBusinessTypeConfigModal.vue?vue&type=script&lang=js"
export * from "./mallRegisterBusinessTypeConfigModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports